/**
 * 映射基础图形中的控制点的特殊name属性
 */
export const prstGeomGdNames = {
    frame: ['adj1'],
    mathPlus: ['adj1'],
    mathMinus: ['adj1'],
    mathMultiply: ['adj1'],
    hexagon: ['adj', 'vf'],
    star5: ['adj', 'hf', 'vf'],
    star6: ['adj', 'hf'],
    star7: ['adj', 'hf', 'vf'],
    star10: ['adj', 'hf'],
};
